export default __webpack_public_path__ + "static/media/scopes.0ff4f4ad.config";